import { cosemApi } from '@services/providers/cosem';
import { ApiResponse } from '@services/providers/cosem.types';
import { FileToEdit } from './file';

const fileApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        editFile: build.mutation<ApiResponse<FileToEdit>, { id: number, documentName: string }>({
            query: ({ id, documentName }) => {
                return { 
                    url: `/cdn/file/${id}`,
                    body: {
                        documentName
                    },
                    method: 'PUT',
                };
            },
            transformResponse: (response: ApiResponse<FileToEdit>) => response
        }),
    })
});

export const { 
    useEditFileMutation
} = fileApi;
